/**
 * Created by Jerker Nord on 2020-05-28.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {MonkeysGoldScatterLandView} from "./MonkeysGoldScatterLandView";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MGReelEvents} from "../../reel/MGReelPartAnimator";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {MonkeysGoldParsedInitData} from "../../server/data/MonkeysGoldParsedInitData";

export class MonkeysGoldScatterLandController extends ReelStopPresentationController {

    private _scatterLandView:MonkeysGoldScatterLandView;
    private _mode:string;
    private _nextMode:string;

    constructor(index:number) {
        super(index, "MonkeysGoldScatterLandController");
        this._scatterLandView = MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView = new MonkeysGoldScatterLandView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, MGReelEvents.SYMBOLS_ALL_OUT, (event:GameEvent) => this.onAllSymbolsOut(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    public playScatterLandAnimation(scatterSymbol:StateReelSymbol, targetPosition:number):void {
        let isBonusGame:boolean = false;
        if(this._mode == GameMode.FREESPIN || this._mode == GameMode.FREESPIN_AVALANCHE) {
            isBonusGame = true;
        }
        this._scatterLandView.playScatterLandAnimation(scatterSymbol, isBonusGame, targetPosition);
    }

    private onAllSymbolsOut(reelId:number):void {
        this._scatterLandView.cleanUp(reelId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }

    public abort():void {
    }
}